import { useSelector, useDispatch } from "react-redux";
import { orange } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Grid, IconButton, Tooltip, Button } from "@material-ui/core";
import { useEffect } from "react";
import { Alert } from "@material-ui/lab";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";

import {
  obtenerPasajerosDocumentos,
  modalPasajeroCheckin,
  targetPasajeroCheckin,
  updatePasajeroCheckinValidate,
} from "../../../ducks/clientesDuck";
import FCheckIn from "./FCehckIn";
import { FormatoFechaIso } from "./../../../utils/FormatFecha";
import { catRoles } from "../../../constant/catRoles";
import { usePermiso } from "../../../hooks/usePermiso";
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
import { ToastMessage } from "../../../global/ToastMessage";

const useStyles = makeStyles({
  table: {
    minWidth: 900,
  },
  header: {
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
  },
});

const VCheckIn = () => {
  const { pasajeros, cliente, referencia } = useSelector(
    (store) => store.cliente
  );
  const { profile } = useSelector((store) => store.logeo);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [permitidoCheckIn] = usePermiso({
    location: "FK_AdministrarClientes_CheckIn_edit",
    initialValue: false,
  });

  useEffect(() => {
    dispatch(
      obtenerPasajerosDocumentos({
        idPaquete: cliente?.paquete?.Id_Paquete,
      })
    );
  }, [dispatch, cliente?.paquete?.Id_Paquete]);

  const handleOpenModal = ({ pasajero }) => {
    dispatch(modalPasajeroCheckin({ open: true }));
    dispatch(targetPasajeroCheckin({ pasajero }));
  };

  const handleValidateCheckin = () => {
    dispatch(onLoadAnction({ message: "" }));
    dispatch(
      updatePasajeroCheckinValidate({ IdPaquete: cliente?.paquete?.Id_Paquete })
    ).then((Response) => {
      dispatch(offLoadAction());
      if (Response?.status === 500) {
        ToastMessage.fire({
          title: "¡Error al realizar la operación!",
          icon: "error",
          confirmButtonColor: "#009bdb",
          confirmButtonText: "Aceptar",
        });
        return null;
      }
      if (Response?.status === 400) {
        ToastMessage.fire({
          title: "¡No se fue posible completar la operación!",
          text: Response.Message,
          icon: "warning",
          confirmButtonColor: "#009bdb",
          confirmButtonText: "Aceptar",
        });
        return null;
      }
      ToastMessage.fire({
        title: "Operacion exitosa",
        icon: "success",
        confirmButtonColor: "#009bdb",
        confirmButtonText: "Aceptar",
      });
      dispatch(
        obtenerPasajerosDocumentos({
          idPaquete: cliente?.paquete?.Id_Paquete,
        })
      );
    });
  };

  if (!referencia)
    return (
      <Alert className="alerta" severity="info">
        Seleccione un cliente
      </Alert>
    );

  return (
    <Grid container>
      <Grid item xs={12}>
        <div
          style={{
            marginTop: "1rem",
            marginBottom: "1rem",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleValidateCheckin}
          >
            Aplicar checkin
          </Button>
        </div>
      </Grid>

      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="tabla pasajeros">
            <TableHead>
              <TableRow>
                <TableCell className={classes.header} align="center">
                  #
                </TableCell>
                <TableCell className={classes.header} align="center">
                  Tipo
                </TableCell>
                <TableCell className={classes.header} align="center">
                  Nombre
                </TableCell>
                <TableCell className={classes.header} align="center">
                  Apellido paterno
                </TableCell>
                <TableCell className={classes.header} align="center">
                  Apellido materno
                </TableCell>
                <TableCell className={classes.header} align="center">
                  Nacimiento
                </TableCell>
                <TableCell className={classes.header} align="center">
                  Pasaporte
                </TableCell>
                <TableCell className={classes.header} align="center">
                  Vigencia
                </TableCell>
                <TableCell className={classes.header} align="center">
                  CheckIn
                </TableCell>
                <TableCell className={classes.header} align="center">
                  Creado
                </TableCell>
                <TableCell className={classes.header} align="center">
                  Documento
                </TableCell>
                {(profile.Rol?.Id === catRoles.ADMINISTRADOR ||
                  permitidoCheckIn) && (
                  <TableCell className={classes.header} align="center">
                    Acción
                  </TableCell>
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {pasajeros.map((row, index) => (
                <TableRow key={index + 1}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">
                    {row?.TipoPasajero?.Descripcion}
                  </TableCell>
                  <TableCell align="center">
                    {row?.Pasajero?.Nombre || "No registrado"}
                  </TableCell>
                  <TableCell align="center">
                    {row?.Pasajero?.ApellidoPaterno || "No registrado"}
                  </TableCell>
                  <TableCell align="center">
                    {row?.Pasajero?.ApellidoMaterno || "No registrado"}
                  </TableCell>
                  <TableCell align="center">
                    {row?.Pasajero?.FechaNacimiento
                      ? FormatoFechaIso({
                          date: row?.Pasajero?.FechaNacimiento,
                          formato: "dd/MM/yyyy",
                        })
                      : "No registrado"}
                  </TableCell>
                  <TableCell align="center">
                    {row?.Pasajero?.documento?.NumeroPasaporte ||
                      "No registrado"}
                  </TableCell>
                  <TableCell align="center">
                    {row?.Pasajero?.documento?.FechaVencimiento
                      ? FormatoFechaIso({
                          date: row?.Pasajero?.documento?.FechaVencimiento,
                          formato: "dd/MM/yyyy",
                        })
                      : "No registrado"}
                  </TableCell>
                  <TableCell align="center">
                    {row?.Pasajero?.CheckIn ? (
                      <Tooltip title="Aplicado">
                        <CheckCircleIcon style={{ color: "green" }} />
                      </Tooltip>
                    ) : (
                      <Tooltip title="No Aplicado">
                        <ErrorIcon style={{ color: orange[400] }} />
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {FormatoFechaIso({
                      date: row?.Pasajero?.FechaRegistro,
                      formato: "dd-MM-yyyy",
                    })}
                  </TableCell>
                  <TableCell align="center">
                    {FormatoFechaIso({
                      date: row?.Pasajero?.documento?.FechaRegistro,
                      formato: "dd-MM-yyyy",
                    })}
                  </TableCell>
                  {(profile.Rol?.Id === catRoles.ADMINISTRADOR ||
                    permitidoCheckIn) && (
                    <TableCell align="center">
                      <IconButton
                        onClick={() => handleOpenModal({ pasajero: row })}
                        size="small"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <FCheckIn />
    </Grid>
  );
};

export default VCheckIn;
